import React, {createContext, useCallback, useContext, useMemo, useState} from 'react';
import {SystemContext} from "./SystemContext";
import ErrorReportingService from './ErrorReportingService';

export const VipCardContext = createContext();


export const VipCardProvider = ({ children }) => {
    const [selectedVipCard, setSelectedVipCard] = useState(null);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const { vipCards = [], fetchSystemData, admins } = useContext(SystemContext) || {};



    // remove* declared first so the memoized select* handlers can list them as
    // deps. All four are useCallback-stable (setters are stable), so the context
    // value below only changes when the selected card/employee or vipCards change.
    const removeVipCard = useCallback(() => {
        setSelectedVipCard(null);
    }, []);
    const removeEmployee = useCallback(() => {
        setSelectedEmployee(null);
    }, []);

    const selectVipCard = useCallback((vipCard) => {
        if (!vipCard) return;

        const wholeVIPObject = vipCards && vipCards.find ? vipCards.find(v => v.id === vipCard.id) : null;
        if(wholeVIPObject){
            removeEmployee();
            setSelectedVipCard(wholeVIPObject);
        }else{
            removeEmployee();
            setSelectedVipCard(vipCard)
        }
    }, [vipCards, removeEmployee]);
    const selectEmployee = useCallback((obj) => {
        if(obj){
            removeVipCard();
            setSelectedEmployee(obj);
        }else{
            ErrorReportingService.error("No employee selected", {}, "VipCardContext");
        }

    }, [removeVipCard]);

    const value = useMemo(() => ({
        selectedVipCard, selectVipCard, removeVipCard, selectEmployee, selectedEmployee, removeEmployee,
    }), [selectedVipCard, selectVipCard, removeVipCard, selectEmployee, selectedEmployee, removeEmployee]);

    return (
        <VipCardContext.Provider value={value}>
            {children}
        </VipCardContext.Provider>
    );
};
